import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import { controlBtnSizes } from '../../constants';
import styles from './ControlBtn.module.scss';

const ControlBtn = ({
  className,
  onClick,
  icon,
  btnSize = controlBtnSizes.medium,
  shape = 'circle',
  ...props
}) => {
  return (
    <Button
      className={cn(styles.root, className, styles[btnSize])}
      onClick={onClick}
      icon={icon}
      shape={shape}
      {...props}
    />
  );
};

export default ControlBtn;
